<template>
  <div
    class="box-folding"
    :class="{
      'no-divider': noDivider,
      'is-open': isOpen,
    }"
  >
    <header
      class="box-folding__switcher"
      @click="isOpen = !isOpen"
    >
      <component
        :is="titleLevelTag"
        class="box-folding__title-wrap"
      >
        <span class="box-folding__title-icon">
          <img
            :src="require('@/assets/icons/icon-arrow-down.svg')"
            alt=""
          >
        </span>
        <span class="box-folding__title">
          <slot name="title">{{ title }}</slot>
        </span>
        <span
          v-if="$slots.counter || counter"
          class="box-folding__counter"
        >
          <slot name="counter">{{ counter }}</slot>
        </span>
      </component>
    </header>
    <transition-expand>
      <div
        v-show="isOpen"
        class="box-folding__content"
      >
        <div class="box-folding__content-holder">
          <slot name="default" />
        </div>
      </div>
    </transition-expand>
  </div>
</template>

<script>
import TransitionExpand from '@/components/tiny/TransitionExpand';

export default {
  components: {
    TransitionExpand,
  },
  props: {
    value: {
      type: Boolean,
      default: true,
    },
    counter: {
      default: null,
      validator: function (value) {
        return ['string', 'number'].indexOf(typeof value) !== -1 || value === null;
      },
    },
    noDivider: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: 'Default Title',
    },
    titleLevel: {
      type: [Number, String],
      default: 3,
      validator(val) {
        return +val >= 2 || +val <= 6;
      },
    },
  },
  data() {
    return {
      isOpen: this.value,
    };
  },
  computed: {
    titleLevelTag() {
      return `h${this.titleLevel}`;
    },
  },
  watch: {
    value(value) {
      this.isOpen = value;
    },
  },
};
</script>

<style lang="scss" scoped>
.box-folding {
  background-color: #32325a;
  color: #b4b4d3;
  border: 1px solid #42526e;
  position: relative;

  &.no-divider {
    border: none;
  }

  &.no-divider &__content {
    &-holder {
      border-top: none;
      padding-top: 4px;
      padding-bottom: 10px;
    }
  }

  &.no-divider &__switcher {
    padding-top: 9px;
    padding-bottom: 9px;
    @media screen and (max-width: 1024px) {
      padding-top: 5px;
      padding-bottom: 5px;
    }
  }

  &__switcher {
    padding: 19px 30px 19px 65px;
    user-select: none;
    cursor: pointer;
    position: relative;
    transition: background-color 0.15s ease-in-out;
    @media screen and (max-width: 1024px) {
      padding: 10px 15px 10px 35px;
    }

    .no-touchevents &:hover {
      background-color: #42526e;
    }
    &:active {
      background-color: #42526e;
    }
  }

  .no-touchevents &__switcher:hover &__title-icon {
    opacity: 1;
  }
  &__switcher:active &__title-icon {
    opacity: 1;
  }

  &__title-wrap {
    position: relative;
  }
  &__title {
    font-size: 14px;
    line-height: 20px;
    font-weight: bold;
    color: #fff;
    text-transform: uppercase;
    vertical-align: middle;
    & + * {
      margin-left: 7px;
    }
    @media screen and (max-width: 1024px) {
      font-size: 12px;
    }
  }
  &__title-icon {
    position: absolute;
    top: 50%;
    left: -16px;
    transform: translate(-50%, -50%) rotate(-90deg);
    opacity: 0.2;
    transform-origin: 50% 50%;
    width: 12px;
    height: 6px;
    will-change: opacity, transform;
    transition-property: opacity, transform;
    transition-duration: 0.15s;
    transition-timing-function: ease-in-out;
    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
  &.is-open &__title-icon {
    transform: translate(-50%, -50%);
    opacity: 1;
  }

  &__content {
    font-size: 14px;
    line-height: 20px;
    position: relative;

    @media screen and (max-width: 1024px) {
      font-size: 12px;
    }

    &-holder {
      position: relative;
      border-top: 1px solid #42526e;
      padding: 20px 30px 20px 65px;
      @media screen and (max-width: 1024px) {
        padding: 10px 15px 10px 20px;
      }
    }
  }

  &__counter {
    display: inline-block;
    vertical-align: middle;
    background: #f3b758;
    color: #32325a;
    height: 11px;
    padding: 1px 5px 0;
    font-size: 10px;
    line-height: 10px;
    font-weight: bold;
    border-radius: 5px;
  }
}
</style>
